import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { numberWithCommas } from '@helpers/utils';

type BundleFooterPriceProps = {
  salePrice: number;
  fullPrice: number;
};

const BundleFooterPrice = ({ salePrice, fullPrice }: BundleFooterPriceProps) => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  const isFree = salePrice === 0;

  if (isFree) {
    return (
      <Typography component="span" sx={{ typography: { md: 'h1', xs: 'h4', color: 'white' } }}>
        {t('course_detail.header_banner.purchase.free_course.text')}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: {
          md: 'flex',
          xs: 'block',
        },
        alignItems: 'center',
        minWidth: '100px',
      }}
    >
      <Typography component="span" sx={{ typography: { md: 'h1', xs: 'h4', color: 'white' } }}>
        {t('course_detail.header_banner.price', { price: numberWithCommas(salePrice) })}
      </Typography>
      {salePrice < fullPrice ? (
        <Typography
          component="span"
          className="strike-center"
          sx={{
            fontSize: {
              md: '24px',
              xs: '18px',
            },
            fontWeight: {
              md: 400,
              xs: 500,
            },
            lineHeight: {
              md: '36px',
              xs: '22px',
            },
            letterSpacing: '1px',
            color: theme.palette.textOnPrimary.secondary,
            mx: {
              md: '1.5rem',
              xs: '0px',
            },
          }}
        >
          {t('course_detail.header_banner.price', { price: numberWithCommas(fullPrice) })}
        </Typography>
      ) : null}
    </Box>
  );
};

export default BundleFooterPrice;
